import React, { Component } from 'react';
import { Route } from 'react-router';
import { renderRoutes } from 'react-router-config';
import { type Location } from 'history';
import { fetchAsyncProps } from './core';
import { type AsyncConnectContext } from './types';

export class AsyncConnect extends Component<
  AsyncConnectContext,
  { previousLocation: Location | null }
> {
  private mounted = false;

  private loadDataCounter = 0;

  constructor(props: AsyncConnectContext) {
    super(props);
    this.state = {
      previousLocation: this.isLoaded() ? null : props.location,
    };
  }

  componentDidMount() {
    this.mounted = true;
    if (!this.isLoaded()) {
      this.fireAsyncPropsFetch(this.props);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: AsyncConnectContext) {
    if (this.props.location !== nextProps.location) {
      this.fireAsyncPropsFetch(nextProps);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  isLoaded() {
    return Boolean(this.props.store.getState().reduxAsyncConnect?.loaded);
  }

  async fireAsyncPropsFetch({
    store,
    location,
    beginGlobalLoad,
    endGlobalLoad,
    ...otherProps
  }: AsyncConnectContext): Promise<void> {
    const previousLocation = this.props.location;

    this.loadDataCounter += 1;
    const requestNumber = this.loadDataCounter;

    this.setState({ previousLocation });
    beginGlobalLoad?.();

    try {
      await fetchAsyncProps({ ...otherProps, location, store });
      if (this.loadDataCounter === requestNumber && this.mounted) {
        this.setState({ previousLocation: null });
      }
    } catch {
      if (this.loadDataCounter === requestNumber && this.mounted) {
        this.setState({ previousLocation: null });
      }
    } finally {
      endGlobalLoad?.();
    }
  }

  render() {
    const { previousLocation } = this.state;
    const { location } = this.props;

    return (
      <Route
        location={previousLocation || location}
        render={() => renderRoutes(this.props.routes)}
      />
    );
  }
}
